import queryString from 'query-string'

const cookieName = $(document.body).data('donation-modal-cookie-name')
const $showOnPages = $(['dashboards-show', 'search-listings', 'listings-show', 'blog_posts-show', 'pages-show'])
const donationPopup = createDonationPopup()

$('.js-c-popups-donations .actions .later').on('click', function () {
  const $donateLaterContainer = $('.js-c-popups-donations--donate_later.init--hidden')

  $donateLaterContainer.slideDown('fast')
  $donateLaterContainer.find('input').focus()
})

$('.js-c-popups-donations--donate_later .submit').on('click', function () {
  const $emailInput = $('.js-c-popups-donations__email_input')

  $emailInput.removeClass('error')

  $.ajax({
    type: 'POST',
    url: '/list_subscriptions',
    dataType: 'json',
    data: {
      list_subscription: { email: $emailInput.val() },
      list_type: 'core',
      mc_segments: [
        $('.c-popups-donations--donate_later').attr('data-mc-segment-name'),
      ],
    },
    success: function () {
      donationPopup.dismiss(365)
      donationPopup.close()
    },
    error: function () {
      $emailInput.addClass('error').focus()
    },
  })
})

$('.js-c-footer-popup__close').on('click', function () {
  donationPopup.dismiss(1)
  donationPopup.close()
})

donationPopup.init(function () {
  const $popup = donationPopup.element()
  const params = queryString.parse(window.location.search, { arrayFormat: 'bracket' })
  // TODO: should be decided by the controller, not a class list
  const pageIsOnAllowList = $showOnPages.filter((_, klass) => $(document.body).hasClass(klass)).length > 0
  // `window.disableDonationPopup` is currenlt added by a partial, so views are resonsible for setting this value.
  // Thats a bit dodgy - should be refactored to be on the controller instead
  const shouldShowFooterPopup = window.disableDonationPopup !== true && pageIsOnAllowList && $popup.length >= 1
  const shouldForceFooterPopup = params.donate !== undefined
  const cookieSayShowThePopup = $.cookie(cookieName) !== 'true'

  if (shouldShowFooterPopup && (shouldForceFooterPopup || cookieSayShowThePopup)) {
    donationPopup.show()
  }
})

function createDonationPopup() {
  const $popup = $('.js-c-popups-donations')

  return {
    init: function (callback) {
      if ($.isFunction(callback)) callback.call(this)
      return this
    },
    element: function () {
      return $popup
    },
    show: function () {
      var self = this
      var $donateButton = $popup.find('#js-c-popups-donations-donate')

      $donateButton.on('click', () => self.dismiss(365))
      $popup.fadeIn('fast')
    },
    close: function() {
      $popup.fadeOut('fast')
    },
    dismiss: function (numberOfDays) {
      $.cookie(cookieName, true, {
        expires: numberOfDays,
        path: '/',
      })
    },
  }
}
